import React, { useState } from 'react'
import NEH from './NappsEventHandlers'
import { Link, useLoaderData, useLocation, useNavigation, useParams } from 'react-router-dom'
import { AppBoxesDetail } from "./AppBoxes";
import { ErrorBoundary, ErrorFallback, NotDefined, truncate_letters } from "./helpers/utils";
import useTokenData from "./helpers/tokenData";
import { useDeviceWidth } from "./useDeviceWidth";
import { NavBar } from "./Base";
import Footer from "./Footer";
import { getApp } from './loaders/appLoaders';
import { PageHeaderLink } from './helpers/elements';


export async function loader({ params }) {
  const app = await getApp(params.appNameId);
  return { app };
}

const singleAppData = (app_name, state) => {
}

function AppDetailLoading(props) {
  return (
    <section>Loading...</section>
  )
}

function AppDetailContent(props) {
  const [appData, setAppData] = useState({
    appDetails: null,
    networkError: false,
    isAppsLoading: false,
    responseDetails: ''
  })
  const { rawToken, isLoggedIn, tokenData } = useTokenData();
  const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();

  const OwnerContact = () => {
    return (
      <section className={"d-block every:decoration-none|color-initial dark:every:color-whitesmoke"}>
        <Link to={props.owner.id === tokenData?.user_id ? "/profile" : `/user/${props.owner.id}`}
          className="flex flex-row justify-start align-items-center pad-2 decoration-none color-initial radius hover:bg-lighter dark:hover:bg-111314BB">
          <img src={props.owner.dp} alt="" width={"48"} height={"48"}
            className="square-6 lh-6 radius-circle bg-lighter dark:bg-222324" />
          <div className="pad-x1 font-medium">{props.owner.firstname} {props.owner.lastname}</div>
        </Link>
        <a href={`mailto:${props.owner.email}`} id="id-app-owner-email"
          className="d-block pad-l4 pad-r2 pad-y2 radius hover:bg-lighter dark:hover:bg-111314BB">
          <span className="fa fa-envelope square-4 lh-4 pad-r1 color-999"></span>
          <span className={"pad-x1"}>{props.owner.email}</span>
        </a>
        <a href={`tel:${props.owner.phone_no}`} id="id-app-owner-email"
          className="d-block pad-l4 pad-r2 pad-y2 radius hover:bg-lighter dark:hover:bg-111314BB">
          <span className="fa fa-phone square-4 lh-4 pad-r1 color-999"></span>
          <span className={"pad-x1"}>{props.owner.phone_no || "-"}</span>
        </a>
        <div id="id-app-owner-email" className="pad-l4 pad-r2 pad-y2">
          <span className="fa fa-earth-africa square-4 lh-4 pad-r1 color-999"></span>
          <span className={"pad-x1"}>{props.owner.address || '-'}</span>
        </div>
      </section>
    );
  }

  return (
    <section className={"flex flex-column"}>
      {/*<AppBoxesDetail
          key={props.id}
          id={props.id}
          name={props.name}
          description={props.description}
          category={props.category}
          {...props}
      />*/}

      {
        windowWidth < deviceWidthEnum.laptop
          // ? <div className={"fixed top-0 left-0 flex flex-row align-items-center pct:w-100 h-10 bg-white bg-mica z-2"}>
          //   <Link to="/"
          //     className="d-block square-8 lh-9 top-0 left-1 lg:top-4|left-4|square-8|lh-8 color-initial text-center z-10 decoration-none">
          //     <span className="fa fa-angle-left font-18 color-999"></span>
          //   </Link>
          //   {/*<header
          //          className={"d-block pct:w-100 h-10 lh-10 pad-x2 font-18 font-bold text-left color-444A44"}>
          //          {props.name}
          //      </header>*/}
          //   {
          //     props.owner.id === tokenData?.user_id
          //       ? <Link to={`/app/${props.name_id}/update`}
          //         className={"abs px:top-20 right-4 h-5 lh-5 bg-green radius pad-x2 decoration-none color-white"}>
          //         Edit
          //         <span className={"fa fa-pen pad-l1 color-white"}></span>
          //       </Link>
          //       : null
          //   }
          // </div>
          ? <PageHeaderLink fixTop={true}>
            {
              props.owner.id === tokenData?.user_id
                ? <Link to={`/app/${props.name_id}/update`}
                  className={"abs px:top-20 right-4 h-5 lh-5 bg-green radius pad-x2 decoration-none color-white"}>
                  Edit
                  <span className={"fa fa-pen pad-l1 color-white"}></span>
                </Link>
                : null
            }
          </PageHeaderLink>
          : <NavBar />
      }

      {/*<section
          className={"flex flex-row flex-nowrap pct:w-100 overflow-x-auto justify-start pad-x1 every:radius-sm"}>
        <img src={props.logo} alt={`${props.name} logo`} className="h-320 pct:w-88 bg-light gradient:to_top_right-lightgray-whitesmoke radius-top-left radius-top-right object-cover object-center" />
        {
          props.screenshot.map((image, index) => (
              <div className={"flex-grow flex-noshrink pct:w-48 h-320 bg-lighter pad-x-2 radius-inherit"}>
                <img key={index} src={image.image}
                     alt={`screenshot preview ${index}`} height={"100%"}
                     className={"pct:max-w-100 object-cover object-center radius-inherit"}/>
              </div>
          ))
        }
      </section>*/}
      <section
        className={"fixed px:top-80 flex flex-row flex-nowrap justify-around pct:w-100 h-200 z-0 every:text-center|h-240|radius-sm lg:relative|top-0|h-480 lg:every:h-480"}>
        {
          props?.screenshot.length > 0
            ? props?.screenshot.map((image, index) => (
              <>
                <div key={index} className={"pct:w-100 mg-x-auto pad-x-2 radius-inherit lg:pad-x1"}>
                  <img src={image.image}
                    alt={`screenshot preview ${index}`} height={"100%"}
                    className={"pct:max-w-100 pct:w-100 object-cover object-center radius-inherit"} />
                </div>
                <div className={"abs bottom-0 pct:w-100 bg-transparent"}></div>
              </>
            ))
            : <div className={"relative flex flex-column justify-center align-items-center pct:w-100 lh-normal bg-lighter gradient:to_bottom-whitesmoke-lightgray color-lightgray font-64 font-bold text-center lg:align-items-start|pad-x-400 dark:gradient:to_bottom-111314-222425|color-darkgray|radius-unset"}>{props.name}</div>
        }
      </section>
      <section className={"pct:w-100 mg-x-auto lg:flex|flex-row|justify-between|align-items-start|pct:w-100|pad-x4 dark:bg-inherit"}>
        <section
          className="app-banner-container relative px:top-280 pct:w-100 pct:max-w-100 overflow-y-auto mg-auto bg-lighter bg-mica2 radius2 z-1 shadow:0px--20px-80px-20px-FFFFFF88 lg:neg:top-80|pct:w-56|mg-x4|mg-l-auto|bg-initial dark:shadow:0px--20px-80px-20px-11131488 dark:bg-111314|bg-mica-unset">
          {/*<img src="" alt="" id="id-app-banner-image" className="app-banner-image"/>*/}
          {/*<section className="app-primary-details">
            <div id="id-app-name" className="app-name">{props.name}</div>
            <div id="id-app-description" className="app-description">{props.description}</div>
            <div id="id-app-category" className="app-category">
              {props.category.split(',').map((each_app_category) => {
                return (<span
                  className="d-inline-block pad-x2 h-4 lh-4 mg-x1-smt radius-round bg-light font-normal font-10">{each_app_category}</span>)
              })}
            </div>
          </section>*/}

          <section className={"relative bg-lighter pad-x-2 pad-b-2 radius2 lg:mg-b3|pad-1|radius2 dark:bg-222425 dark:lg:mg-b2"}>
            {
              /* For mobile, tablet and devices smaller than the laptop */
              windowWidth < deviceWidthEnum.laptop
                ? <div className="relative flex flex-row justify-start align-items-center pad-t4 pad-b2 pad-x1 font-semibold font-21 text-center bg-inherit z-2 dark:color-whitesmoke dark:every:bg-333334|color-whitesmoke">
                  {
                    props.logo
                      ? <img src={props.logo} alt={`${props.name} logo`}
                        className="d-block mg-x2 mg-y2 w-64 h-64 bg-light radius-circle object-cover object-center dark:bg-333334" />
                      : <div
                        className={"relative d-block mg-x2 square-8 lh-8 radius-circle border-0 border-DDD border-solid bg-light text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease dark:bg-333334"}>
                        {props?.name?.split('')[0].toUpperCase().toString()}
                      </div>
                  }
                  {props.name}
                </div>
                : null
            }
            {
              /* For laptop and larger devices */
              windowWidth >= deviceWidthEnum.laptop
                ? <div
                  className="relative flex flex-row align-items-center pad-t4 pad-b2 pad-x3 font-semibold font-21 radius-inherit bg-inherit every:d-block|mg-x2|mg-y2|w-108|h-108|lh-108|radius-circle|bg-light dark:color-whitesmoke dark:every:bg-333334|color-whitesmoke">
                  {
                    props.logo
                      ? <img src={props.logo} alt={`${props.name} logo`}
                        className="object-cover object-center dark:bg-lighter" />
                      :
                      <div
                        className={"relative border-0 border-DDD border-solid text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease dark:hover:shadow:inset-0px-0px-8px-0px-222425"}>
                        {props?.name?.split('')[0].toUpperCase().toString()}
                      </div>
                  }
                  {props.name}
                </div>
                : null
            }
            <div className="pad-x3 pad-t1 pad-b3 bg-inherit radius-bottom-left radius-bottom-right lg:font-14|lh-40|pad-x5|bg-inherit dark:color-whitesmoke">{props.truncate_description ? truncate_letters(props.description, 0, 160) : props.description}</div>

            {
              windowWidth >= deviceWidthEnum.laptop &&
                props.owner.id === tokenData?.user_id
                ? <Link to={`/app/${props.name_id}/update`}
                  className={"abs px:top-40 right-4 h-5 lh-5 bg-green radius pad-x2 decoration-none color-white"}>
                  Edit
                  <span className={"fa fa-pen pad-l1 color-white"}></span>
                </Link>
                : null
            }

            <div className="flex flex-row flex-nowrap pad-x1 pad-y2 bg-white-solid radius overflow-x-auto lg:pad-x4|bg-inherit dark:bg-222425">
              {
                props.category && props.category.split(',').map((each_app_category, index) => {
                  return (
                    <span key={index}
                      className="d-inline-block pad-x2 h-5 lh-5 mg-x1-smt mg-y1-smt radius-sm border:1px_solid_DDD bg-E8E8E8 font-normal font-11 lg:h-6|lh-6|border-0|font-12 dark:bg-111314BB|color-whitesmoke|border:1px_solid_222425">
                      {each_app_category}
                    </span>
                  )
                })
              }
            </div>
          </section>

          <section className={""}>
            <section className="app-download-details radius2 bg-white-solid dark:bg-222425|mg-b2">
              {/*<header className={"font-medium"}>{"Download links".toUpperCase()}</header>*/}
              <section
                className={"flex flex-row justify-start pad-y5 empty:pad-0 radius2 bg-white-solid overflow-x-auto every:w-auto|h-64|radius|text-center|radius-inherit|decoration-none|bg-lighter|color-initial|mg-x1|pad-r4 hover:every:bg-E8E8E8|cursor-pointer dark:bg-inherit|pad-x2 dark:every:bg-333435|color-whitesmoke dark:hover:every:bg-333435"}>
                {
                  props.playstore_link !== ""
                    ? <a href={props.playstore_link}
                      target={"_blank"}
                      rel={"noreferrer"}
                      id="id-app-download-links"
                      className={"flex flex-row align-items-center lg:font-13"}>
                      {/*<span className="fa-brands fa-google-play d-block font-30 pad-t4 pad-b2"></span>*/}
                      <img
                        src="/static/playstore.png"
                        alt={"playstore logo"}
                        width={"32"}
                        height={"32"}
                        className={"mg-x2"} />
                      {"Play Store"}
                    </a>
                    : null
                }
                {
                  props.appstore_link !== ""
                    ? <a href={props.appstore_link}
                      target={"_blank"}
                      rel={"noreferrer"}
                      id="id-app-download-links"
                      className={"flex flex-row align-items-center lg:font-13"}>
                      {/*<span className="fa-brands fa-app-store-ios d-block font-30 pad-t4 pad-b2"></span>*/}
                      <img
                        src="/static/appstore.png"
                        alt={"appstore logo"}
                        width={"32"}
                        height={"32"}
                        className={"mg-x2"} />
                      {"App Store"}
                    </a>
                    : null
                }
                {
                  props.external_link !== ""
                    ? <a href={props.external_link}
                      target={"_blank"}
                      rel={"noreferrer"}
                      id="id-app-download-links"
                      className={"flex flex-row align-items-center lg:font-13"}>
                      {/*<span className="fa fa-download d-block font-30 pad-t4 pad-b2"></span>*/}
                      <img
                        src="/static/download.png"
                        alt={"download logo"}
                        width={"32"}
                        height={"32"}
                        className={"mg-x2"} />
                      {"Download"}
                    </a>
                    : null
                }
              </section>
              {props.external_link ?
                <div className={"pad-x2 pad-b2 font-medium dark:color-whitesmoke"}>{"** This app has an external download link."}</div> : null}
            </section>

            <section className={"bg-white-solid mg-t-2 pad-x1 pad-t2 radius2-top-left radius2-top-right every:d-block|decoration-none|pad-x2|pad-y3 lg:pad-t4 dark:bg-222425"}>
              <div id="id-app-version" className={"app-version"}>
                <span className="fa fa-code-commit square-4 lh-4 pad-r1 color-999"></span>
                <span className={"pad-x1 lg:font-13 dark:color-whitesmoke"}>Version: {props.version}</span>
              </div>
              {
                props.website
                  ? <a
                    href={props.website}
                    target={"_blank"}
                    rel={"noreferrer"}
                    id="id-app-website"
                    className={"app-website decoration-none color-initial radius overflow-x-auto text-ellipsis hover:bg-lighter dark:hover:bg-111314BB"}>
                    <span className="fa fa-globe square-4 lh-4 pad-r1 color-999"></span>
                    <span className={"pad-x1 lg:font-13 dark:color-whitesmoke"}>Website: {props.website}</span>
                  </a>
                  : <div
                    id="id-app-website"
                    className={"app-website decoration-none color-initial radius cursor-not-allowed hover:bg-lighter dark:hover:bg-111314BB"}>
                    <span className="fa fa-globe square-4 lh-4 pad-r1 color-999"></span>
                    <span className={"pad-x1 lg:font-13 dark:color-whitesmoke"}>Website: -</span>
                  </div>
              }
            </section>

            <section className={"app-secondary-details flex flex-column pad-y1 bg-white-solid every:pad-y1 dark:bg-222425"}>
              {/*<header className={"radius pad-x2 font-14 font-medium"}>
                  {"App details".toUpperCase()}
              </header>*/}
              {/*<div id="id-app-details" className="app-details">{props.details}</div>*/}
            </section>

            <section className={"app-download-details flex flex-column mg-t-2 pad-y4 bg-white-solid dark:bg-222425"}>
              <header className={"radius pad-x2 font-14 font-medium pad-y1 lg:font-18|pad-y2 dark:color-whitesmoke"}>{"Download links"}</header>
              <section className={"pad-x1 pad-t1 every:d-block|decoration-none|pad-x2|pad-y3"}>
                <a href={props.playstore_link || void (0)} target={"_blank"} rel={"noreferrer"} id="id-app-download-links"
                  className={"color-initial radius dark:hover:bg-111314BB"}>
                  <span className="fab fa-google-play square-4 lh-4 pad-r1 color-999 lg:font-13"></span>
                  <span className={"pad-x1 lg:font-13 dark:color-whitesmoke"}>{props.playstore_link ? "Download from Google play store" : "-"}</span>
                </a>
                <a href={props.appstore_link || void (0)} target={"_blank"} rel={"noreferrer"} id="id-app-download-links"
                  className={"color-initial radius dark:hover:bg-111314BB"}>
                  <span className="fab fa-app-store-ios square-4 lh-4 pad-r1 color-999 lg:font-13"></span>
                  <span className={"pad-x1 lg:font-13 dark:color-whitesmoke"}>{props.appstore_link ? "Download from Apple AppStore" : "-"}</span>
                </a>
                <a href={props.external_link || void (0)} target={"_blank"} rel={"noreferrer"} id="id-app-download-links"
                  className={"color-initial radius dark:hover:bg-111314BB"}>
                  <span className="fa fa-link square-4 lh-4 pad-r1 color-999 lg:font-13"></span>
                  <span className={"pad-x1 lg:font-13 dark:color-whitesmoke"}>{props.external_link ? "External Download" : "-"}</span>
                </a>
              </section>
            </section>

            {
              windowWidth < deviceWidthEnum.laptop
                ? <section className={"app-owner-details flex flex-column mg-t-2 pad-y4 bg-white-solid every:pad-y1 dark:bg-222425"}>
                  <Link to={props.owner.id === tokenData?.user_id ? "/profile" : `/user/${props.owner.id}`}
                    className={"radius pad-x2 font-14 font-medium decoration-none color-initial dark:color-whitesmoke"}>
                    {"Owner details"}
                    <span className={"fa fa-angle-right abs right-4 font-18"}></span>
                  </Link>
                  <OwnerContact />
                </section>
                : null
            }
          </section>
        </section>
        {
          windowWidth >= deviceWidthEnum.laptop
            ? <section className={"app-owner-details relative flex flex-column justify-start align-items-start px:top-400 pct:w-32"}>
              <section className={"pct:w-80 mg-r-auto pad-x2 pad-y4 radius2 bg-white-solid every:pad-y1 dark:bg-222425"}>
                <Link to={props.owner.id === tokenData?.user_id ? "/profile" : `/user/${props.owner.id}`}
                  className={"radius pad-x2 font-14 font-medium decoration-none color-initial dark:color-whitesmoke"}>
                  {"Owner details"}
                  {/*<span className={"fa fa-angle-right abs right-4 font-18"}></span>*/}
                </Link>
                <OwnerContact />
              </section>
            </section>
            : null
        }
      </section>
    </section>
  )
}

/*const withRouter = WrappedComponent => props => {
  const params = useParams();
  // etc... other react-router-dom v6 hooks

  return (
    <WrappedComponent
      {...props}
      params={params}
      // etc...
    />
  );
};*/

// export function withRouter(Children) {
//   return (props) => {

//     const match = { params: useParams() }
//     const location = useLocation()
//     return <Children {...props} match={match} location={location} />
//   }
// }

// class AppDetail extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       appDetails: null,
//       networkError: false,
//       isAppsLoading: false,
//       responseDetails: ''
//     }
//   }

//   componentDidMount() {
//     const fetch_headers = {
//       method: 'GET',
//       headers: {
//         'Accept': 'application/json',
//         // 'Origin': '*',
//       },
//       modes: 'cors',  // options: cors, no-cors, same-origin
//       cache: 'default',   // options: default, no-store, reload, no-cache, force-cache, only-if-cached
//     }
//     fetch(`${process.env.REACT_APP_BASE_URL}/app/${this.props.match.params.id}/`, fetch_headers)
//       .then(response => {
//         if (response.status > 400) {
//           return this.setState({
//             responseDetails: 'Error fetching apps. Try again.'
//           })
//         }
//         console.log(response)
//         return response.json()
//       })
//       .then(data => {
//         console.log(data)
//         this.setState({
//           appDetails: data
//         })
//       }).catch(err => {
//         console.log('Error fetch latest apps: ' + err)
//         this.setState({
//           appDetails: null,
//           responseDetails: 'Error fetching Latest Apps.',
//           networkError: true,
//           isAppsLoading: false
//         })
//       })
//   }

//   componentWillUnmount() { }

//   render() {
//     console.log(this.props)
//     return (
//       <section id="id-app-details-fragment" className="app-details-container pct:h-100">
//         {/*<section id="id-app-details-navigation-container" className="modes-navigation-container">
//           <Link to="/" id="id-modes-navigation-close-trigger"
//                 className="fa fa-times fa-2x modes-navigation-close-trigger-right bg-green"
//                 onClick={new NEH().closeAppsDetailsTemplate}></Link>
//           <span className="modes-navigation-title">
//             <span className="fa fa-search fa-lg modes-navigation-icon"></span>
//             Search
//           </span>
//         </section>*/}
//         <section className="d-block pct:h-100 overflow-y-auto">
//           {/*<Link to="/" id="id-modes-navigation-close-trigger"
//                 className="fa fa-arrow-left font-18 d-block fixed top-1 left-2 z-100 square-8 lh-8 text-center radius-circle bg-light decoration-none color-initial"
//                 onClick={new NEH().closeAppsDetailsTemplate}></Link>*/}
//           {
//             this.state.appDetails !== null
//               ? <AppDetailsContent {...this.state.appDetails} />
//               : <div className={"loading-animation"}></div>
//           }
//         </section>
//         <Footer miniDetails={""} noFix={true} />
//       </section>
//     )
//   }
// }

// const AppDetailWithRouter = withRouter(AppDetail)
// export default withRouter(AppDetail)


function AppDetail() {
  const { app } = useLoaderData();
  const navigation = useNavigation();

  return (
    <section id="id-app-details-fragment" className={"app-details-container pct:h-100"}>
      {/* <ErrorBoundary fallbackComponent={ErrorFallback}> */}
      <section className={"d-block pct:h-100 overflow-y-auto" + navigation.state === "idle" ? "opacity-40 next-page-animation" : ""}>
        {
          app?.data !== null && <AppDetailContent {...app?.data} />
          // : <div className={"loading-animation"}>ABC</div> || <NoPage />
        }
        {/* {
          navigation.state === "loading"
            ? <AppDetailLoading />
            : <AppDetailContent {...app?.appDetail} />
        } */}
      </section>
      {/* </ErrorBoundary> */}
      <Footer miniDetails={""} noFix={true} />
    </section>
  )
}

export default AppDetail;